<template>
  <Drawer
    :id="drawerId"
    title="Reactivate Subscription"
    padded
  >
    <div>
      <PaymentSelector @paymentMethodSelected="(id) => (paymentMethodId = id)" />
      <mcs-btn
        color="primary"
        block
        large
        :loading="processing"
        :disabled="!paymentMethodId"
        class="mt-5"
        @click="reactivate"
      >
        Reactivate Subscription
      </mcs-btn>
      <div
        v-if="nextChargeDate"
        class="body-2 my-3"
      >
        *** Since there is still unused time on your subscription
        <strong>you will not be charged</strong> until {{ nextChargeDate }}.
      </div>
      <mcs-alert
        v-show="error"
        type="error"
        class="mt-3"
        :text="error"
      />
    </div>
  </Drawer>
</template>

<script>
import Drawer from '../../components/layout/Drawer';
import PaymentSelector from '../../components/payments/PaymentSelector';
import { DRAWERS } from '../../utils/constants';

export default {
  name: 'ReactivateDrawer',

  components: {
    Drawer,
    PaymentSelector
  },

  data() {
    return {
      paymentMethodId: 0,
      drawerId: DRAWERS.REACTIVATE_SUBSCRIPTION_DRAWER,
      error: '',
      processing: false
    };
  },

  computed: {
    nextChargeDate() {
      return this.$store.state.subscription.item.setToCancelOnDisplay;
    }
  },

  methods: {
    reactivate() {
      var payload = {
        paymentMethodId: this.paymentMethodId,
        subscriptionId: this.$store.state.subscription.item.subscriptionId,
        promoCode: this.$store.state.subscription.reactivationPromoCode
      };
      this.processing = true;
      this.$store
        .dispatch('subscription/reactivate', payload)
        .then(async (result) => {
          if (result.success) {
            await this.$store.dispatch('subscription/getDetail');
            this.$store.commit('drawers/CLOSE_ALL');
            this.$root.$snackbarSuccess('Subscription Reactivated');
          } else {
            this.error = result.message;
          }
        })
        .finally(() => {
          this.processing = false;
        });
    }
  }
};
</script>

<style scoped></style>
